module.exports = __webpack_public_path__ + "img/sustainability-image.1c865b94.png";